// extracted by mini-css-extract-plugin
module.exports = {"parallax":"styles_parallax__1Qe1n","project":"styles_project__2dgBO"};